import { render, staticRenderFns } from "./MyLikes.vue?vue&type=template&id=3326be04&scoped=true"
import script from "./MyLikes.vue?vue&type=script&lang=js"
export * from "./MyLikes.vue?vue&type=script&lang=js"
import style0 from "./MyLikes.vue?vue&type=style&index=0&id=3326be04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3326be04",
  null
  
)

export default component.exports